var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.resource.isDownloadable ? _c('div', [_c('ResourcePreviewFile', {
    attrs: {
      "resource": _vm.resource
    },
    on: {
      "click": function click($event) {
        return _vm.downloadResourceAsset(_vm.resource);
      }
    }
  }), _c('BaseButton', {
    class: (_class = {}, _class[_vm.$style.downloadButton] = true, _class[_vm.$style.pageButton] = !_vm.modalButton, _class[_vm.$style.modalButton] = _vm.modalButton, _class),
    attrs: {
      "theme": "white"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadResourceAsset(_vm.resource);
      }
    }
  }, [_c('MottoIcon', {
    attrs: {
      "name": "Download",
      "icon-color": "gray"
    }
  }), _c('p', {
    staticClass: "button-text color-dark-gray"
  }, [_vm._v(_vm._s(_vm.downloadLabel))])], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }